var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    key: 'address' + _vm.key,
    attrs: {
      "margin": 0,
      "flat": "",
      "outlined": "",
      "hideTitle": true,
      "subtitle": _vm.$t('components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.parties.companies')
    }
  }, [_c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.COMPANY,
      "field": _vm.partnerId
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('select-entity', {
    attrs: {
      "value": _vm.reportDto.towingCompanyId,
      "partnerId": _vm.partnerId,
      "refType": _vm.ResourceEnum.COMPANY,
      "filters": _vm.createFilter(_vm.CompanyServiceEnum.TOWING),
      "clearable": true,
      "label": _vm.$t('objects.report.towingCompanyId')
    },
    on: {
      "input": _vm.addTowing
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('select-entity', {
    attrs: {
      "value": _vm.reportDto.workshopCompanyId,
      "partnerId": _vm.partnerId,
      "refType": _vm.ResourceEnum.COMPANY,
      "filters": _vm.createFilter(_vm.CompanyServiceEnum.WORKSHOP),
      "clearable": true,
      "label": _vm.$t('objects.report.workshopCompanyId')
    },
    on: {
      "input": _vm.addWorkshop
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('select-entity', {
    attrs: {
      "value": _vm.reportDto.insuranceCompanyId,
      "partnerId": _vm.partnerId,
      "refType": _vm.ResourceEnum.COMPANY,
      "filters": _vm.createFilter(_vm.CompanyServiceEnum.INSURANCE),
      "clearable": true,
      "label": _vm.$t('objects.report.insuranceCompanyId')
    },
    on: {
      "input": _vm.addInsurance
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('select-entity', {
    attrs: {
      "value": _vm.reportDto.appraiserCompanyId,
      "partnerId": _vm.partnerId,
      "refType": _vm.ResourceEnum.COMPANY,
      "filters": _vm.createFilter(_vm.CompanyServiceEnum.APPRAISER),
      "clearable": true,
      "label": _vm.$t('objects.report.appraiserCompanyId')
    },
    on: {
      "input": _vm.addAppraiser
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('select-entity', {
    attrs: {
      "value": _vm.reportDto.rentalCompanyId,
      "partnerId": _vm.partnerId,
      "refType": _vm.ResourceEnum.COMPANY,
      "filters": _vm.createFilter(_vm.CompanyServiceEnum.RENTAL),
      "clearable": true,
      "label": _vm.$t('objects.report.rentalCompanyId')
    },
    on: {
      "input": _vm.addRental
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('select-entity', {
    attrs: {
      "value": _vm.reportDto.attorneyCompanyId,
      "partnerId": _vm.partnerId,
      "refType": _vm.ResourceEnum.COMPANY,
      "filters": _vm.createFilter(_vm.CompanyServiceEnum.LAWYER),
      "clearable": true,
      "label": _vm.$t('objects.report.attorneyCompanyId')
    },
    on: {
      "input": _vm.addAttorney
    }
  })], 1)], 1)], 1), _c('Can', {
    attrs: {
      "I": _vm.ActionEnum.READ,
      "a": _vm.ResourceEnum.PERSON,
      "field": _vm.partnerId
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }